// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__OkXwl","primary":"Tag_primary__htqqW","secondary":"Tag_secondary__S16Pv","deselect":"Tag_deselect__Ilrr4","info":"Tag_info__zWKje"};